var _regeneratorRuntime = require("/Users/bene/dev/mdx-live-editor/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/bene/dev/mdx-live-editor/node_modules/@babel/runtime/helpers/asyncToGenerator");

var unified = require('unified');

var toMDAST = require('remark-parse');

var squeeze = require('remark-squeeze-paragraphs');

var visit = require('unist-util-visit');

var raw = require('hast-util-raw');

var toMDXAST = require('./md-ast-to-mdx-ast');

var mdxAstToMdxHast = require('./mdx-ast-to-mdx-hast');

var mdxHastToJsx = require('./mdx-hast-to-jsx');

var _require = require('./util'),
    isImport = _require.isImport,
    isExport = _require.isExport,
    isExportDefault = _require.isExportDefault,
    BLOCKS_REGEX = _require.BLOCKS_REGEX,
    EMPTY_NEWLINE = _require.EMPTY_NEWLINE;

var DEFAULT_OPTIONS = {
  footnotes: true,
  mdPlugins: [],
  hastPlugins: [],
  compilers: [],
  blocks: [BLOCKS_REGEX]
};

var tokenizeEsSyntax = function tokenizeEsSyntax(eat, value) {
  var index = value.indexOf(EMPTY_NEWLINE);
  var subvalue = index !== -1 ? value.slice(0, index) : value;

  if (isExport(subvalue)) {
    return eat(subvalue)({
      type: 'export',
      default: isExportDefault(subvalue),
      value: subvalue
    });
  }

  if (isImport(subvalue)) {
    return eat(subvalue)({
      type: 'import',
      value: subvalue
    });
  }
};

tokenizeEsSyntax.locator = function (value, _fromIndex) {
  return isExport(value) || isImport(value) ? -1 : 1;
};

function esSyntax() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.blockTokenizers;
  var methods = Parser.prototype.blockMethods;
  tokenizers.esSyntax = tokenizeEsSyntax;
  methods.splice(methods.indexOf('paragraph'), 0, 'esSyntax');
}

function createMdxAstCompiler(options) {
  var mdPlugins = options.mdPlugins;
  var fn = unified().use(toMDAST, options).use(esSyntax).use(squeeze, options).use(toMDXAST, options);
  mdPlugins.forEach(function (plugin) {
    // Handle [plugin, pluginOptions] syntax
    if (Array.isArray(plugin) && plugin.length > 1) {
      fn.use(plugin[0], plugin[1]);
    } else {
      fn.use(plugin, options);
    }
  });
  fn.use(mdxAstToMdxHast, options);
  return fn;
}

function applyHastPluginsAndCompilers(compiler, options) {
  var hastPlugins = options.hastPlugins;
  var compilers = options.compilers; // Convert raw nodes into HAST

  compiler.use(function () {
    return function (ast) {
      visit(ast, 'raw', function (node) {
        var _raw = raw(node),
            type = _raw.type,
            children = _raw.children,
            tagName = _raw.tagName,
            properties = _raw.properties;

        node.type = type;
        node.children = children;
        node.tagName = tagName;
        node.properties = properties;
      });
    };
  });
  hastPlugins.forEach(function (plugin) {
    // Handle [plugin, pluginOptions] syntax
    if (Array.isArray(plugin) && plugin.length > 1) {
      compiler.use(plugin[0], plugin[1]);
    } else {
      compiler.use(plugin, options);
    }
  });
  compiler.use(mdxHastToJsx, options);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = compilers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var compilerPlugin = _step.value;
      compiler.use(compilerPlugin, options);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return compiler;
}

function createCompiler(options) {
  var compiler = createMdxAstCompiler(options);
  var compilerWithPlugins = applyHastPluginsAndCompilers(compiler, options);
  return compilerWithPlugins;
}

function sync(mdx, options) {
  var opts = Object.assign({}, DEFAULT_OPTIONS, options);
  var compiler = createCompiler(opts);
  var fileOpts = {
    contents: mdx
  };

  if (opts.filepath) {
    fileOpts.path = opts.filepath;
  }

  var _compiler$processSync = compiler.processSync(fileOpts),
      contents = _compiler$processSync.contents;

  return contents;
}

function compile(_x) {
  return _compile.apply(this, arguments);
}

function _compile() {
  _compile = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(mdx) {
    var options,
        opts,
        compiler,
        fileOpts,
        _ref,
        contents,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            opts = Object.assign({}, DEFAULT_OPTIONS, options);
            compiler = createCompiler(opts);
            fileOpts = {
              contents: mdx
            };

            if (opts.filepath) {
              fileOpts.path = opts.filepath;
            }

            _context.next = 7;
            return compiler.process(fileOpts);

          case 7:
            _ref = _context.sent;
            contents = _ref.contents;
            return _context.abrupt("return", contents);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _compile.apply(this, arguments);
}

compile.sync = sync;
module.exports = compile;
exports = compile;
exports.sync = sync;
exports.createMdxAstCompiler = createMdxAstCompiler;
exports.default = compile;